const IMAGE_DIMENSIONS = [
    { width: 240, height: 200 },
    { width: 48, height: 40 }
]

export const getDimensions = inventoryCampaign => {
    const raw = inventoryCampaign?.inventory?.img_lg?.toString() || "";
    const normalized = raw.replace(/х/g, 'x').replace(/Х/g, 'x');
  
    const splitted = normalized.split('x');
  
    if (splitted.length === 2) {
      const [w, h] = splitted.map(Number);
      return [
        { width: w, height: h },
        { width: w / 5, height: h / 5 }
      ];
    }
  
    return IMAGE_DIMENSIONS;
  };
